<script lang="ts">
  import { onMount } from "svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { loadDashboard, tiles } from "./dashboard.store";

  onMount(loadDashboard);
</script>

<MainLayout>
  {#if !!$tiles}
    <div class="tile is-ancestor dashboard-tiles noselect">
      <div class="tile is-parent">
        <article
          class="tile is-child box has-text-centered dashboard-box-leads"
        >
          <p class="title is-size-1 dashboard-tile-text">
            {$tiles.numLeads}
          </p>
          <p class="subtitle dashboard-tile-text">lead</p>
        </article>
      </div>
      <div class="tile is-parent">
        <article
          class="tile is-child box has-text-centered dashboard-box-companies"
        >
          <p class="title is-size-1 dashboard-tile-text">
            {$tiles.numCompanies}
          </p>
          <p class="subtitle dashboard-tile-text">clienti</p>
        </article>
      </div>
      <div class="tile is-parent">
        <article
          class="tile is-child box has-text-centered dashboard-box-companies"
        >
          <p class="title is-size-1 dashboard-tile-text">
            {$tiles.numFornitori}
          </p>
          <p class="subtitle dashboard-tile-text">fornitori</p>
        </article>
      </div>
      <div class="tile is-parent">
        <article
          class="tile is-child box has-text-centered dashboard-box-contacts"
        >
          <p class="title is-size-1 dashboard-tile-text">
            {$tiles.numContacts}
          </p>
          <p class="subtitle dashboard-tile-text">contatti</p>
        </article>
      </div>       
    </div>
  {/if}
</MainLayout>

<style>
  .dashboard-tiles {
    margin-top: 1rem;
  }
  .dashboard-tile-text {
    color: #f8f8f8;
  }
  .dashboard-box-leads {
    background-color: #7799bd;
  }
  .dashboard-box-companies {
    background-color: #7799bd;
  }
  .dashboard-box-contacts {
    background-color: #7799bd;
  }
  .dashboard-box-deals {
    background-color: #7799bd;
  }
</style>
